export const REDUCER_NAME = "productSearchSlice";

export interface iProductImage {
  image: string;
}

export interface iProduct {
  productId: string;
  productName: string;
  productUrl: string;
  sellingPrice: number;
  mrpPrice: number;
  discountPrice: number;
  imageSimilarityScore: number;
  images: iProductImage[];
  tags: string[];
}

export interface iProductSearchState {
  isLoading: boolean;
  // products: iProduct[];
  products: iProduct[] | null;
  errorMessage: string | null;
}
